
export default function ServicesHero() {
  return (
    <section 
      className="relative py-32 bg-cover bg-center bg-no-repeat animated-sky-bg"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/dd6067d4d567571b23f5f10cadcd887b.jpg')`
      }}
    >
      <div className="absolute inset-0 bg-blue-900/15 floating-overlay"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            事業内容
          </h1>
          <p className="text-xl text-gray-100 max-w-3xl mx-auto leading-relaxed">
            リノベーション、FM・メンテナンス、コンサルティングの3つの事業領域で、
            お客様の大切な資産をトータルサポートいたします。
          </p>
        </div>
      </div>
    </section>
  );
}
